import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  async getSystemParameterByCode(param) {
    try {
      const response = await axios.get(`uni/parameters/code/${param}`)
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data.value
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
}
